module.exports = __webpack_public_path__ + "img/mag-black.2c5e360.svg";